var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLogouttemplate(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 12,
    viewBox: "0 0 10 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.82393 2.78837C2.9386 2.96773 2.89175 3.20981 2.71928 3.32907C1.60686 4.09829 0.875 5.41247 0.875 6.9043C0.875 9.27363 2.72182 11.1943 5 11.1943C7.27815 11.1943 9.125 9.27363 9.125 6.9043C9.125 5.41247 8.39315 4.09829 7.2807 3.32907C7.10825 3.20981 7.0614 2.96773 7.17605 2.78837C7.29075 2.609 7.5235 2.56028 7.69595 2.67953C9.0086 3.58719 9.875 5.14043 9.875 6.9043C9.875 9.7044 7.6924 11.9743 5 11.9743C2.30761 11.9743 0.125 9.7044 0.125 6.9043C0.125 5.14043 0.99141 3.58719 2.30402 2.67953C2.47649 2.56028 2.70926 2.609 2.82393 2.78837Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5 0.793945C5.2071 0.793945 5.375 0.968556 5.375 1.18395V5.34395C5.375 5.55933 5.2071 5.73394 5 5.73394C4.7929 5.73394 4.625 5.55933 4.625 5.34395V1.18395C4.625 0.968556 4.7929 0.793945 5 0.793945Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogouttemplate);
export default __webpack_public_path__ + "static/media/logouttemplate.cea77a183979266af8139edd47b4f36b.svg";
export { ForwardRef as ReactComponent };